import React from "react";
import { observer } from "mobx-react";
import { Message } from "semantic-ui-react";
import { withTranslation } from "react-i18next";

const NoCreditCardsMessage = observer(({ t }) => (
  <Message warning>
    <Message.Header>{t("billingCentral:noCreditCards")}</Message.Header>
    <p>
      {t("billingCentral:aCreditCardIsNeededToProceed")}
      <br />
      {t("billingCentral:enterCreditCardInFollowingForm")}
    </p>
  </Message>
));

export default withTranslation()(NoCreditCardsMessage);
